class TrCartTotalPill extends HTMLElement {
  constructor() {
    super();
    this.cartUpdateUnsubscriber = undefined;
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      this.refresh();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  async refresh() {
    try {
      const response = await fetch(`${window.location.pathname}?section_id=tr-cart-total-pill`);
      if (!response.ok) return;
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.querySelector('tr-cart-total-pill');
      if (next) {
        this.innerHTML = next.innerHTML;
      }
    } catch (e) {
      // silent fail — pill stays stale, full page nav will resync
    }
  }
}

customElements.define('tr-cart-total-pill', TrCartTotalPill);
